import Box from "@mui/material/Box";

import { marketingPalette } from "./tokens";

/** `.faq-main_toggle_icon-wrap` and the glyph inside it, measured at 1440. */
const WRAP = 35.2;
const GLYPH = 16;

/**
 * The control a published FAQ row toggles with.
 *
 * Not MUI's `ExpandMore`: that is a filled 24px chevron sitting on the row's
 * own ground, where the published one is a 16px stroked chevron centred in a
 * 35px white panel with an 8px corner. The difference is the row's tallest
 * element, which is why every FAQ page reads as misaligned without it.
 */
export default function FaqToggleIcon() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 auto",
        width: `${WRAP}px`,
        height: `${WRAP}px`,
        p: "9.6px",
        borderRadius: "8px",
        backgroundColor: "common.white",
        // The glyph is stroked in `currentColor`, and MUI's own expand-icon
        // wrapper would otherwise hand it a grey.
        color: marketingPalette.ink,
      }}
    >
      <FaqChevron />
    </Box>
  );
}

/** The glyph alone, for the blog's rows: they draw it without the panel. */
export function FaqChevron() {
  return (
    <Box
      component="svg"
      viewBox="0 0 66 64"
      fill="none"
      aria-hidden
      sx={{ width: `${GLYPH}px`, height: `${GLYPH}px` }}
    >
      {/* `non-scaling-stroke` keeps the published weight at any size. */}
      <path
        d="M1 19L33 51L65 19"
        stroke="currentColor"
        strokeWidth="0.13rem"
        vectorEffect="non-scaling-stroke"
      />
    </Box>
  );
}
